
import Vue from "vue";
import Component from "vue-class-component";
import {BModal} from "bootstrap-vue";
import DropdownSelector from "@/components/DropdownSelector.vue";
import {CargoOperationModel, CargoOperationType, factory, HarbourOption, ResultError} from "@/api-client";
import {Prop} from "vue-property-decorator";
import toasts from "@/components/Toasts";

@Component({
    components: {
        DropdownSelector
    }
})
export default class CargoOperationModal extends Vue {
    @Prop({required: true})
    harbourOptions!: HarbourOption[];

    typeOptions = [
        {text: this.$ls.Documents_Practices_CargoOperationType_Loading, value: CargoOperationType.Loading},
        {text: this.$ls.Documents_Practices_CargoOperationType_Unloading, value: CargoOperationType.Unloading},
    ];

    model: CargoOperationModel = factory.create(CargoOperationModel);
    validationErrors: ResultError = factory.create(ResultError);

    $refs!: { bModal: BModal };

    mounted() {
        this.$refs.bModal.$on("show", () => this.reset());
    }

    private addCargoOperation() {
        this.validateCargoOperation(this.model);

        if (this.validationErrors.isEmpty) {
            this.$emit("add", this.model);
            this.hideModal();
            toasts.success(this.$ls.Global_Toast_AddSuccess);
        } else {
            this.setValidationErrors(this.validationErrors, this.$ls.Global_Toast_FormAddFailure);
        }
    }

    private hideModal() {
        this.$refs.bModal.hide();
    }

    private reset() {
        this.validationErrors.clear();
        this.model = factory.create(CargoOperationModel);
        this.model.harbour = this.harbourOptions[0];
    }

    private validateCargoOperation(cargoOperation: CargoOperationModel) {
        this.validationErrors.clear();

        if (!cargoOperation.date)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddCargoOperation_Error_DateIsMandatory, 'date');

        if (!cargoOperation.type)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddCargoOperation_Error_TypeIsMandatory, 'type');
    }
}
